module.exports = __webpack_public_path__ + "static/media/VolEx_logo_pos.818f737d.svg";